exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grey-bg {\n  background-color: #e0e0e0; }\n\n.no-wrap {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.info-label {\n  font-size: 85%;\n  color: #606060; }\n\n.mat-option {\n  line-height: 16px !important;\n  height: 56px !important;\n  padding: 12px 16px !important; }\n\n.mat-option + .mat-option {\n  border-top: 1px solid #a0a0a0 !important; }\n\n.mat-autocomplete-panel {\n  max-height: 300px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/oes/scanned-data/scanned-data-form/scanned-data-form.component.scss
// module id = ../../../../../angular/app/views/oes/scanned-data/scanned-data-form/scanned-data-form.component.scss
// module chunks = main